export const DEFAULT_AVATAR = "data:image/svg+xml;utf8," + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">'
    + '<rect width="40" height="40" rx="20" fill="#e2e8f0"/>'
    + '<circle cx="20" cy="16" r="7" fill="#94a3b8"/>'
    + '<path d="M6 35c0-8.5 6.5-14 14-14s14 5.5 14 14" fill="#94a3b8"/>'
    + '</svg>'
);
